// The data in this file can be generated by opening `scripts/letter-widths.html` in your browser.
export const letterSpacing = 1;
export const widths = {
    "0": 16,
    "1": 12,
    "2": 16,
    "3": 15,
    "4": 16,
    "5": 15,
    "6": 16,
    "7": 15,
    "8": 15,
    "9": 16,
    a: 15,
    b: 16,
    c: 15,
    d: 17,
    e: 15,
    f: 10,
    g: 16,
    h: 18,
    i: 9,
    j: 8,
    k: 17,
    l: 9,
    m: 27,
    n: 18,
    o: 16,
    p: 17,
    q: 16,
    r: 12,
    s: 14,
    t: 10,
    u: 18,
    v: 16,
    w: 23,
    x: 16,
    y: 17,
    z: 15,
    A: 21,
    B: 19,
    C: 18,
    D: 20,
    E: 18,
    F: 18,
    G: 19,
    H: 22,
    I: 9,
    J: 16,
    K: 20,
    L: 17,
    M: 27,
    N: 22,
    O: 20,
    P: 18,
    Q: 20,
    R: 20,
    S: 17,
    T: 19,
    U: 22,
    V: 21,
    W: 28,
    X: 20,
    Y: 19,
    Z: 17,
    "/": 10,
    "-": 11,
    _: 15,
    "(": 9,
    ")": 9,
    "?": 13,
    "!": 6,
    " ": 6,
};
export const styles = {
    "font-family": "Roboto Slab",
    "font-weight": "bold",
    "font-size": "30px",
    "letter-spacing": "-1px",
};
